import { Link } from "react-router-dom";
import { Calendar, UserPlus, Shuffle, Handshake, Aperture, GalleryHorizontalEnd, Camera, Users } from "lucide-react";
import { StepCard } from "../components/StepCard";
import { SectionHeading } from "../components/SectionHeading";

const STEPS = [
  { icon: Calendar, title: "Choose a Session", description: "Find a session that fits your vibe, location and schedule." },
  { icon: UserPlus, title: "Create Your Stranger Profile", description: "Tell us about yourself, your preferences and the type of connection you're open to." },
  { icon: Shuffle, title: "We Match", description: "We pair you with another stranger based on preferences, compatibility and session requirements." },
  { icon: Handshake, title: "Meet & Connect", description: "Arrive alone. Your host introduces you to your Stranger." },
  { icon: Aperture, title: "Capture the Moment", description: "Your photographer guides the experience while capturing genuine moments." },
  { icon: GalleryHorizontalEnd, title: "Get Your Photos", description: "Relive the experience through your professional photo gallery." },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <section className="bg-midnight-black py-20 text-center">
        <p className="text-stranger-orange text-xs font-bold tracking-[0.25em] uppercase mb-3">Meet. Connect. Capture.</p>
        <h1 className="text-clean-white font-extrabold uppercase tracking-tight text-3xl sm:text-5xl max-w-3xl mx-auto px-5">How Stranger Sessions Work</h1>
      </section>

      <section className="bg-warm-white py-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-14">
            {STEPS.map((s, i) => (
              <StepCard key={s.title} number={i + 1} icon={s.icon} title={s.title} description={s.description} />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-clean-white py-24">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <SectionHeading eyebrow="Ready?" title="Choose Your Path" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Link to="/photographers/join" data-testid="how-it-works-photographer-cta" className="bg-midnight-black text-clean-white rounded-2xl p-8 flex flex-col items-start hover:-translate-y-1 transition-transform duration-300">
              <Camera className="w-8 h-8 text-stranger-orange mb-4" />
              <h3 className="font-extrabold uppercase text-xl mb-2">I'm a Photographer</h3>
              <p className="text-clean-white/70 font-medium text-sm">We handle the strangers. You handle the camera.</p>
            </Link>
            <Link to="/find-a-session" data-testid="how-it-works-stranger-cta" className="bg-warm-white border border-soft-gray text-midnight-black rounded-2xl p-8 flex flex-col items-start hover:-translate-y-1 transition-transform duration-300">
              <Users className="w-8 h-8 text-stranger-orange mb-4" />
              <h3 className="font-extrabold uppercase text-xl mb-2">I Want to Be a Stranger</h3>
              <p className="text-midnight-black/70 font-medium text-sm">Come alone. Leave with a story.</p>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
